"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewPanel = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const AuditDisplay_1 = __importDefault(require("../AuditDisplay"));
const reviewDecisionStatusHelper_1 = require("../../../services/admin/reviewDecisionStatusHelper");
const useObjectReview_1 = require("../../../services/admin/useObjectReview");
const InterviewPanel = ({ interview, audits, showAuditErrorCode }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)(['admin']);
    const formattedTripsDate = interview.assignedDate ? (0, moment_1.default)(interview.assignedDate).format('LL') : '-';
    const reviewStatus = (0, useObjectReview_1.useReviewDecisionStatusByObject)('interview', interview.uuid);
    const statusClassName = (0, reviewDecisionStatusHelper_1.getReviewDecisionStatusBoxClass)(reviewStatus);
    const languages = ((_a = interview.paradata) === null || _a === void 0 ? void 0 : _a.languages) || [];
    const formattedLanguages = languages.map((language) => language.language || '?').join('|') || '?';
    return (react_1.default.createElement("div", { className: "admin__interview-stats", key: "interview" },
        react_1.default.createElement("details", { open: true, className: statusClassName || undefined },
            react_1.default.createElement("summary", null,
                react_1.default.createElement("h4", { style: { display: 'inline', margin: 0 } }, t('Interview'))),
            react_1.default.createElement("span", { className: "_widget" },
                t('interviewStats.labels.uuid'),
                ": ",
                react_1.default.createElement("span", { className: "_strong" }, interview.uuid)),
            react_1.default.createElement("span", { className: "_widget" },
                t('interviewStats.labels.accessCode'),
                ":",
                ' ',
                react_1.default.createElement("span", { className: "_strong" }, interview.accessCode || t('survey:None'))),
            react_1.default.createElement("span", { className: "_widget" },
                t(`interviewStats.labels.interviewLanguage${languages.length > 1 ? 's' : ''}`),
                ":",
                ' ',
                react_1.default.createElement("span", { className: "_strong" }, formattedLanguages)),
            react_1.default.createElement("span", { className: "_widget" },
                t('interviewStats.labels.travelDate'),
                ": ",
                react_1.default.createElement("span", { className: "_strong" }, formattedTripsDate)),
            audits && audits.length > 0 && (react_1.default.createElement(AuditDisplay_1.default, { audits: audits, showAuditErrorCode: showAuditErrorCode })))));
};
exports.InterviewPanel = InterviewPanel;
//# sourceMappingURL=InterviewPanel.js.map